// extracted by mini-css-extract-plugin
export default {"header":"kyTl77aTPeDg3jrI9FJn","smallHeader":"hLwg8DXHIVrgcBeOpYfT","closeIcon":"Ah5Ip01OuW0c2bEv8yHF","tabs":"nfZJfkQ0Zohbi0Mxz_1K"};